var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.currentTab=='majorCourse')?_c('myself-course'):(_vm.currentTab=='courseTask')?_c('course-task'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }